/* tslint:disable */
import { Observable } from 'rxjs';
import { Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent } from '@angular/common/http';

import {
  BaseApiClient,
  RequestContext,
  ApiConfigManager,
  HttpRequestState,
} from '@sg/api/base-api-lib';
import { LegalEntitiesApiConfig } from '../api-config';

import { LegalEntitiesApi } from '../models';

@Injectable()
export class LegalEntitiesAnalyzerUploadsApiClient extends BaseApiClient<LegalEntitiesApiConfig> {
  constructor(httpClient: HttpClient, config: ApiConfigManager) {
    super(httpClient, config.legalEntitiesApiConfig);
  }

  legalEntitiesAnalyzerUploadsControllerGetAnalyzerUploads(
    params: { xSgUser?: string; lenderId: string },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<Array<LegalEntitiesApi.AnalyzerUploadDto>>;
  legalEntitiesAnalyzerUploadsControllerGetAnalyzerUploads(
    params: { xSgUser?: string; lenderId: string },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<HttpResponse<Array<LegalEntitiesApi.AnalyzerUploadDto>>>;
  legalEntitiesAnalyzerUploadsControllerGetAnalyzerUploads(
    params: { xSgUser?: string; lenderId: string },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<Array<LegalEntitiesApi.AnalyzerUploadDto>>;
  legalEntitiesAnalyzerUploadsControllerGetAnalyzerUploads(
    params: { xSgUser?: string; lenderId: string },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpRequestState<Array<LegalEntitiesApi.AnalyzerUploadDto>>>;
  legalEntitiesAnalyzerUploadsControllerGetAnalyzerUploads(
    params: { xSgUser?: string; lenderId: string },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpResponse<Array<LegalEntitiesApi.AnalyzerUploadDto>>>;
  legalEntitiesAnalyzerUploadsControllerGetAnalyzerUploads(
    params: { xSgUser?: string; lenderId: string },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpEvent<Array<LegalEntitiesApi.AnalyzerUploadDto>>>;
  legalEntitiesAnalyzerUploadsControllerGetAnalyzerUploads(
    params: { xSgUser?: string; lenderId: string },
    options: {
      observe?:
        | 'responsePromise'
        | 'bodyPromise'
        | 'response'
        | 'body'
        | 'bodyWithState'
        | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {},
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['lenderId', params.lenderId]);

    requestContext.headers = this.createHeaders(options.headers || {}, [
      'x-sg-user',
      params.xSgUser,
    ]);

    this.setAcceptHeader(requestContext, 'application/json');

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.get<Array<LegalEntitiesApi.AnalyzerUploadDto>>(
      `${this.basePath}/gateway/admin/legal-entities/${this.encodeURI(String(params.lenderId))}/analyzer-uploads`,
      <any>Object.assign(baseOptions, {}),
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  legalEntitiesAnalyzerUploadsControllerDeleteAnalyzerUpload(
    params: {
      body?: LegalEntitiesApi.DeleteAnalyzerUploadRequest;
      xSgUser?: string;
      lenderId: string;
      uploadId: string;
    },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<LegalEntitiesApi.ErrorResponse>;
  legalEntitiesAnalyzerUploadsControllerDeleteAnalyzerUpload(
    params: {
      body?: LegalEntitiesApi.DeleteAnalyzerUploadRequest;
      xSgUser?: string;
      lenderId: string;
      uploadId: string;
    },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<HttpResponse<LegalEntitiesApi.ErrorResponse>>;
  legalEntitiesAnalyzerUploadsControllerDeleteAnalyzerUpload(
    params: {
      body?: LegalEntitiesApi.DeleteAnalyzerUploadRequest;
      xSgUser?: string;
      lenderId: string;
      uploadId: string;
    },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<LegalEntitiesApi.ErrorResponse>;
  legalEntitiesAnalyzerUploadsControllerDeleteAnalyzerUpload(
    params: {
      body?: LegalEntitiesApi.DeleteAnalyzerUploadRequest;
      xSgUser?: string;
      lenderId: string;
      uploadId: string;
    },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpRequestState<LegalEntitiesApi.ErrorResponse>>;
  legalEntitiesAnalyzerUploadsControllerDeleteAnalyzerUpload(
    params: {
      body?: LegalEntitiesApi.DeleteAnalyzerUploadRequest;
      xSgUser?: string;
      lenderId: string;
      uploadId: string;
    },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpResponse<LegalEntitiesApi.ErrorResponse>>;
  legalEntitiesAnalyzerUploadsControllerDeleteAnalyzerUpload(
    params: {
      body?: LegalEntitiesApi.DeleteAnalyzerUploadRequest;
      xSgUser?: string;
      lenderId: string;
      uploadId: string;
    },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpEvent<LegalEntitiesApi.ErrorResponse>>;
  legalEntitiesAnalyzerUploadsControllerDeleteAnalyzerUpload(
    params: {
      body?: LegalEntitiesApi.DeleteAnalyzerUploadRequest;
      xSgUser?: string;
      lenderId: string;
      uploadId: string;
    },
    options: {
      observe?:
        | 'responsePromise'
        | 'bodyPromise'
        | 'response'
        | 'body'
        | 'bodyWithState'
        | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {},
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['lenderId', params.lenderId], ['uploadId', params.uploadId]);

    const consumes = ['application/json'];

    requestContext.headers = this.createHeaders(options.headers || {}, [
      'x-sg-user',
      params.xSgUser,
    ]);

    this.setAcceptHeader(requestContext, 'application/json');

    this.setContentTypeHeader(requestContext, ...consumes);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.delete<LegalEntitiesApi.ErrorResponse>(
      `${this.basePath}/gateway/admin/legal-entities/${this.encodeURI(String(params.lenderId))}/analyzer-uploads/${this.encodeURI(String(params.uploadId))}`,
      <any>Object.assign(baseOptions, {}),
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }
}
